export default {
  SET_HISTORY(state, data) {
    state.history = data
  },
  ADD_HISTORY_ENTRY(state, data){
    state.history.unshift({...data, createdAt: new Date().toJSON()})
    state.history.pop()
	},
	SET_VALIDATE_HASH(state, data) {
		state.isHash = data
	},
	SET_STEPPED_STATE(state, { undo, redo }) {
		state.canUndo = undo
		state.canRedo = redo
	},
	SET_VALIDATE_ADDRESS(state, data) {
		state.isAddress = data
	},
	SET_SEARCH_VALUE(state, data) {
		state.searchValue = data
	},
	SET_SEARCH_TYPE(state, data) {
		state.searchType = data
	},
	SET_COIN_TYPE(state, data) {
		state.coinType = data
	},
	SET_COIN_DATA(state, data) {
		state.coinData = data
	},
	SET_COIN_CURRENCY_LIST(state, data) {
		state.currencyList = data
	},
	SET_COIN_ESSENTIAL_CURRENCY_LIST(state, data) {
		state.essentialCurrencyList = data
	},
	SET_OLD_NEW_CHAIN_STATE(state, { newChain, oldChain }) {
		state.oldNewChain.oldChain = oldChain
		state.oldNewChain.newChain = newChain
	},
	SET_LAYOUT(state, data) {
		state.activeLayout = data
	},
	SET_RIGHT_TOOLBAR_STATE(state, payload) {
		state.rightToolbarState = payload
	},
	SET_MODAL_PRIVATE_CASE(state, payload) {
		state.modalPrivateCaseState.message = payload ? payload.message : ''
		state.modalPrivateCaseState.open = Boolean(payload)
	},
	SET_GRAPH_LOADING_STATE(state, payload) {
		state.isGraphLoading = payload
	},
  SET_TX_TREE_TOTAL(state, payload) {
		state.txTreeTotal = payload
	},
  SET_TX_TREE_INDEX(state, payload) {
		state.txTreeIndex = payload
	},
  SET_ACTIVE_COIN_DATA(state, payload) {
    state.activeCoinData = payload
  },
  RESET_ACTIVE_COIN_DATA(state) {
    state.activeCoinData = null
  },
  SET_CURRENCY_LIST_MAP(state, payload) {
    state.currenciesListMap = payload
  },
  SET_CONNECTOR_MODE(state, payload) {
    state.connectorMode = payload
  },
	SET_START_POINT_VISIBLE(state, value) {
    state.isStartPointVisible = value
  },
  SET_ACTIVE_BLOCKCHAINS_LIST(state, value) {
		state.activeBlockchainsList = value
	},
	SET_OPENED_AGG_EDGE(state, payload) {
    state.openedAggregatedEdge = payload
  },
	SET_AGG_POPUP_POS(state, pos) {
		state.aggPopupPos = pos
	},
	SET_AGG_POPUP_ZOOM(state, v) {
		state.aggPopupZoom = v || 1
	},
	SET_HOVERED_COMMENT_CARD_ID(state, id) {
		state.hoveredCommentCardId = id
	},
	SET_HOVERED_COMMENT_CARD_DATA(state, data) {
		state.hoveredCommentCardData = data
	},
	SET_COMMENT_CARD_POS(state, pos) {
		state.commentCardPos = pos
	},
  SET_FIND_ON_GRAPH_VALUE(state, payload) {
		state.findOnGraphValue = payload
	},
}
